<template>
  <div class="not-found">
    <NotFoundBlock/>
  </div>
</template>

<script>
import NotFoundBlock from '@/components/NotFoundBlock/NotFoundBlock.vue';

export default {
  name: 'NotFound',
  components: { NotFoundBlock },
  data() {
    return {
      pageTitle: 'Страница не найдена',
    };
  },
  mounted() {
    document.title = this.pageTitle;
  },
};
</script>
